/* eslint-disable */
export default {
  title: '音声',
  dialButtonVolume: 'ダイヤルボタンの音量',
  ringtoneVolume: '着信音の音量',
  callVolume: '通話の音量',
  muteCalls: '通話をミュート',
  outputDevice: '出力デバイス',
  inputDevice: '入力デバイス',
  micPermission: 'マイクロフォンのアクセス許可',
  noDevice: 'デバイスがありません',
  checkMicPermission: 'アクセス許可の確認',
  micNoPermissionMessage:
    'このアプリには、マイクロフォンを使用するためのアクセス許可がありません',
  noLabel: '不明なデバイス',
  notSetSinkIdTip:
    '申し訳ございません。現在のブラウザーのアクセス許可は、オーディオ出力デバイスにアクセスできるように設定されていません。{clickHereLink}して設定方法を確認してください。',
  noLabelTip:
    '申し訳ございません。現在のブラウザーのアクセス許可は、オーディオ入力デバイスにアクセスするように設定されていません。',
  clickHere: 'こちらをクリック',
  defaultOutputDevice: 'デフォルト出力デバイス',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
